import { DateTime } from 'luxon'

import { UsageFilterState } from './types'

export const usageStatusMap: { [key: string]: string } = {
  Success: 'success',
  'In-progress': 'in_progress',
  Failed: 'failed',
}

export const cloudOptions: { [key: string]: string } = {
  AWS: 'AWS',
  GCP: 'GCP',
  Microsoft: 'AZURE',
}

export const initialFilterUsageState: UsageFilterState = {
  status: [],
  cloud: [],
  dateRangeFilter: {
    startDate: DateTime.now().minus({ months: 1 }).toISODate() as string,
    endDate: DateTime.now().toISODate() as string,
  },
}
